<template>
  <div>
    <!-- tab开始 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="'全部 ' + '(' + pageConfig.total + ')'"
        name="0"
      ></el-tab-pane>
      <el-tab-pane
        :label="
          '待打印 ' +
          '(' +
          ((tableData[0] && tableData[0].waitPrintQty) || 0) +
          ')'
        "
        name="10"
      ></el-tab-pane>
      <el-tab-pane
        :label="
          '已打印 ' + '(' + ((tableData[0] && tableData[0].printQty) || 0) + ')'
        "
        name="20"
      ></el-tab-pane>
      <el-tab-pane
        :label="
          '取消 ' + '(' + ((tableData[0] && tableData[0].cancelQty) || 0) + ')'
        "
        name="99"
      ></el-tab-pane>
    </el-tabs>
    <!-- tab结束 -->
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @resetBtn="resetBtn"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:orgIds>
        <el-select
          multiple
          filterable
          v-model="filters.OrgIds"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in organizationList"
            :label="item.customName"
            :value="item.organizationId"
            :key="item.organizationId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
      <template slot-scope="scope" slot="jpContainNo">
      <hoverCopy>
        <el-link slot="referenceChild" :underline="false" type="primary" @click.native="batchesDetail(scope.row)">{{
          scope.row.jpContainNo }}
        </el-link>
      </hoverCopy>
    </template>

     
    </TwTable>
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 36, businessCode: currentRow.outboundNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
    <el-dialog
      title="备货单详情"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      :visible.sync="visibledialogDetail"
      v-model="visibledialogDetail"
      width="80%"
      center
    >
      <el-form>
          <el-table
            :data="detaildata"
            highlight-current-row
            border
            style="width: 100%"
          >
            <el-table-column prop="jpContainNo" label="集拼柜号" min-width="100">
            </el-table-column>
            <el-table-column prop="containNO" label="临柜号" min-width="100">
            </el-table-column>
            <el-table-column prop="estPacingDateText" label="预计装柜" min-width="100">
            </el-table-column>
            <el-table-column prop="sku" label="SKU" min-width="150">
            </el-table-column>
            <el-table-column prop="productNameCN" label="SKU名称" min-width="150">
            </el-table-column>
            <el-table-column prop="skuBarcode" label="条码" min-width="150">
            </el-table-column>
            <el-table-column prop="boxMark" label="唛头(ShipmentID/自营入库单)" min-width="150">
            </el-table-column>
            <el-table-column prop="desWarehouse" label="目的仓" min-width="200">
            </el-table-column>
            <el-table-column prop="singleBoxQty" label="单箱数量" min-width="80">
            </el-table-column>
            <el-table-column prop="boxQty" label="箱数" min-width="60">
            </el-table-column>
            <el-table-column prop="pcs" label="数量" min-width="60">
            </el-table-column>
            <el-table-column prop="singleBoxWeight" label="单箱毛重" min-width="80">
            </el-table-column>
            <el-table-column prop="boxLenght" label="长(cm)" min-width="70">
            </el-table-column>
            <el-table-column prop="boxWidth" label="宽(cm)" min-width="70">
            </el-table-column>
            <el-table-column prop="boxHeight" label="高(cm)" min-width="70">
            </el-table-column>
            <el-table-column prop="deliveryOrdeNo" label="进仓单号" min-width="150">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="150">
            </el-table-column>
          </el-table>
      </el-form>
    </el-dialog>
    <!-- 打印装车单 -->
    <el-dialog
      :visible.sync="printPickListVisible"
      v-model="printPickListVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      class="printDalog"
      title="打印备货清单"
      :width="'400mm'"
      :height="'250mm'"
      style="text-align: center"
    >
      <el-row>
        <div class="print" style="float: right">
          <!-- <el-button type="primary" v-print="printObj" @click="printLoadCar"
            >打印</el-button> -->
          <el-button type="primary" v-print="'#printMe'" @click="printLoadCar()">打印</el-button>
        </div>
      </el-row>

      <div id="printMe" ref="printContent">
        <div class="printList">
          <el-row type="flex" class="row-bg">
            <el-col :span="5"
              ><div class="grid-content bg-purple">
                <strong>预计装柜:{{ outbountPrint.estPacingDateText }}</strong>
              </div></el-col
            >
            <el-col :span="5"
              ><div class="grid-content bg-purple">
                <strong>{{ outbountPrint.desWarehouse }}</strong>
              </div></el-col
            >
            <el-col :span="5"
              ><div class="grid-content bg-purple">
                <strong
                  >{{ outbountPrint.transportType }}({{
                    outbountPrint.jpContainNo
                  }})</strong
                >
              </div></el-col
            >
            <el-col :span="10"
              ><div class="grid-content bg-purple">
                <strong
                  >箱数/体积/毛重：{{ outbountPrint.boxQty }}件/{{
                    outbountPrint.boxVolumn
                  }}CMB/{{ outbountPrint.boxWeight }}KG</strong
                >
              </div></el-col
            >
            <el-col :span="5"
              ><div class="grid-content bg-purple">
                <strong
                  >打印时间：{{ new Date().toLocaleString() }}</strong
                >
              </div></el-col
            >
          </el-row>
        </div>
        <PrintTable :data="boxPrint" :columns="boxPrintColumns">
				</PrintTable>
      </div>
    </el-dialog>
    <!-- 预览图片 -->
    <div>
      <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
        <img v-for="(src, index) in srcList" :src="src" :key="index" />
      </viewer>
    </div>
    
  </div>
</template>
<script>
import {
  getStockingListAsync,
  getStockingDetailAsync,
  exportStockingListAsync,
  getStockingListPrint,
  stockingListStatusPrint,
} from "@/api/outbound/stockingList.js";
import { getReadyforTaskBasis } from "@/api/outbound/readyforTask.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
import OutboundOrderSend from "./OutboundOrderSend.vue";
import html2canvas from "html2canvas";
import printJS from "print-js";
import OutboundOrderDetailDalog from "./OutboundOrderDetailDalog.vue";
import selectAllVue from "../../components/TwTable/selectAll.vue";
import hoverCopy from "../../components/hoverCopy.vue";
import PrintTable from "../../components/printTable.vue";

export default {
  components: {
    LogDialog,
    TwTable,
    OutboundOrderSend,
    OutboundOrderDetailDalog,
    selectAllVue,
    hoverCopy,
    PrintTable
  },
  mixins: [TwTable_mixins],
  data() {
    return {
      activeName: "0",
      outboundNoDalog: "",
      viewtypeDalog: "",
      printObj: {
        id: "printMe",
        popTitle: "拣货单",
        extraCss: "https://www.google.com,https://www.google.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      boxPrintColumns: [
          {
            prop: "containNO",
						label: "货柜号",
						minWidth: "65",
          },
					{
						prop: "sku",
						label: "SKU",
						minWidth: "120",
					},
					{
						prop: "productNameCN",
						label: "SKU名称",
						minWidth: "150",
					},
          {
						prop: "skuBarcode",
						label: "条码",
						minWidth: "80",
					},
					{
						prop: "boxMark",
						label: "唛头",
						minWidth: "80",
					},
					{
						prop: "singleBoxQty",
						label: "单箱",
						minWidth: "40",
					},
					{
						prop: "boxQty",
						label: "箱数",
						minWidth: "40",
					},
          {
						prop: "pcs",
						label: "发货数",
						minWidth: "40",
					},
					{
						prop: "boxVolumnDetail",
						label: "长*宽*高",
						minWidth: "90",
					},
					{
						prop: "boxVolumn",
						label: "总体积",
						minWidth: "50",
					},
					{
						prop: "boxWeight",
						label: "总毛重",
						minWidth: "60",
					},
					{
						prop: "deliveryOrdeNo",
						label: "进仓单号",
						minWidth: "80",
					},
          {
						prop: "feeTypeName",
						label: "增值服务",
						minWidth: "80",
					},
					{
						prop: "remark",
						label: "备注",
						minWidth: "120",
					},
          {
						prop: "storages",
						label: "仓位",
						minWidth: "200",
					},
          
      ],
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        operate: {},
        column: [
          // 表格列配置
          {
            prop: "jpContainNo",
            label: "集拼柜号",
            minWidth: "160",
            slot: true
          },
          {
            prop: "estPacingDateText",
            label: "预计装柜",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "skuCount",
            label: "单据数",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "boxQty",
            label: "总箱数",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "totalVolume",
            label: "总体积(CMB)",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "totalWeight",
            label: "总毛重(KG)",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "desWarehouse",
            label: "目的仓",
            align: "center",
            sortable: true,
            minWidth: "180",
          },
          {
            prop: "stockStatusText",
            label: "状态",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
        ],
      },
      loadingReviewWinodw: "",
      loadingReviewWinodwheight: 800,
      loadingReviewdialogVisible: false,
      organizationList: [], //客户货主
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "documentNos",
            label: "单据号",
            placeholder: "集拼柜号/临柜号",
            clearable: true,
            width: 200,
          },
          {
            type: "input",
            key: "sku",
            label: "SKU",
            placeholder: "",
            clearable: true,
            width: 200,
          },
          
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "预计装柜时间",
          },
        ],
        ///高级搜索配置
        moreSearch: [{
            type: "select",
            key: "orgIds",
            prop: "orgIds",
            label: "客户货主",
            multiple: true,
            slot: true,
            placeholder: "请选择客户货主",
            option: this.organizationList,
          },],
      },
      buttonList: [],
      //-------------
      warehouseList: [],
      transportList: [],
      locationList: [],
      statuslist: [],
      srcList: [],
      detaildata:[],
      visibledialogDetail:false,
      outbountPrint: {},
      boxPrint: [],
      printPickListVisible: false,
      pickingOverVisible: false,
      pickingOverForm: {},
      ContainerTypeList: [],
      completeTask: "",
      loadingReviewdialogTitle: "装车单详情",
      //打托
      addFormVisible: false,
      addLoading: false,
      addForm: {
        SourceId: 0,
        OutboundNo: "",
        BoxCount: "",
        PalletQty: 1,
        Storages: "",
        PalletBoxCount: 0,
      },
      addFormRules: {
        BoxCount: [
          {
            required: true,
            message: "请输入正确的箱数",
            trigger: "blur",
            //pattern: /^[+]?[0-9]?$/,
          },
        ],
        PalletQty: [
          {
            required: true,
            message: "请输入正确的打托数",
            trigger: "blur",
            //pattern: /^[+]?[0-9]?$/,
          },
        ],
        Storages: [
          {
            required: true,
            message: "请输入选择库位",
            trigger: "blur",
            //pattern: /^[+]?[0-9]?$/,
          },
        ],
      },
    };
  },

  created() {
    // 监听子组件的关闭事件
    window.addEventListener(
      "message",
      () => {
        this.closeSelf();
        this.closeReviewdialogVisible();
      },
      false
    );
  },
  methods: {
    handleClick(tab, event) {
      let searchDeep = JSON.parse(JSON.stringify(this.searchData.search));
      searchDeep.forEach((item) => {
        if (item.key == "status" && this.activeName !== "0") {
          item.hide = true;
        } else {
          item.hide = false;
        }
      });
      this.filters.status =
        this.activeName == "0" ? "" : this.activeName.split(",");
      this.$set(this.searchData, "search", searchDeep);
      this.initTable();
    },
    toImg() {
      // 转图片打印
      html2canvas(this.$refs.printContent, {
        backgroundColor: null,
        useCORS: true,
        windowHeight: document.body.scrollHeight,
      }).then((canvas) => {
        // let url = canvas.toDataURL('image/jpeg', 1.0)
        const url = canvas.toDataURL();
        this.img = url;
        printJS({
          printable: url,
          type: "image",
          documentTitle: "打印备货清单",
          style: "@page {margin:0 10mm};",
        });
        console.log(url);
      });
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    closeReviewdialogVisible() {
      // 关闭当前弹框
      this.loadingReviewdialogVisible = false;

      this.initTable();
    },

    // 弹出备货明细
    batchesDetail(row) {
      this.visibledialogDetail = true;
      getStockingDetailAsync({ jpContainNo: row.jpContainNo }).then((res) => {
        if (res.data.success) {
          this.detaildata = res.data.response;
        } else {
          this.$message({
            message: "备货单明细查询失败",
            type: "error",
          });
        }
      });
    },
    closeSelf() {
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    resetBtn() {
      //this.$set(this.filters,'status',[])
      this.filters = {};
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    viewloadingReviewdialog(rowData) {
      this.$refs.OutboundOrderDetailDalog.showDialog(rowData);
    },

    outboundOverSend() {
      this.loadingReviewdialogTitle = "确认出库";
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].outboundStatus != 30) {
        this.$message({
          message: "请选择状态是[待出库]的数据！",
          type: "error",
        });
        return;
      }
      this.$router.push({
        path: "/Outbound/OutboundOrderSendScan",
        query: {
          outboundNo: row[0].outboundNo,
        },
      });
      return;
    },
    //查询列表
    initTable() {
      const { status, documentNos, sku, OrgIds, tdate } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        documentNos,
        sku,
        OrgIds: thereAre(OrgIds),
        stockStatus: status && status.join(",").replace("全选,", ""),
      };
      console.info(para);
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getStockingListAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      const { status, documentNos, sku, OrgIds, tdate } = this.filters;
      let para = {
        page: 1,
        pageSize: 60001,
        documentNos,
        sku,
        OrgIds: thereAre(OrgIds),
        stockStatus: status && status.join(",").replace("全选,", ""),
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }
      this.exportFile(exportStockingListAsync, para);
    },
    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
    //打印查询
    printPickList() {
      let row = this.selectRows.rows;

      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      getStockingListPrint({ jpContainNo: row[0].jpContainNo }).then((res) => {
        if (res.data.success) {
          console.info(res.data.response.orgID);
          if(res.data.response.orgID ==9){
            this.$set(this, 'boxPrintColumns', [
					{
						prop: "deliveryOrdeNo",
						label: "进仓单号",
						minWidth: "120",
					},
          {
						prop: "sku",
						label: "参考单号",
						minWidth: "120",
					},
          {
						prop: "feeTypeName",
						label: "增值服务",
						minWidth: "100",
					},
					{
						prop: "boxQty",
						label: "箱数",
						minWidth: "40",
					},
					{
						prop: "boxVolumn",
						label: "总体积",
						minWidth: "80",
					},
					{
						prop: "boxWeight",
						label: "总毛重",
						minWidth: "80",
					},
          {
						prop: "storages",
						label: "仓位",
						minWidth: "200",
					},
          {
						prop: "remark",
						label: "备注",
						minWidth: "120",
					},
      ])}else{
         this.$set(this, 'boxPrintColumns', [{
            prop: "containNO",
						label: "货柜号",
						minWidth: "65",
          },
					{
						prop: "sku",
						label: "SKU",
						minWidth: "120",
					},
					{
						prop: "productNameCN",
						label: "SKU名称",
						minWidth: "150",
					},
          {
						prop: "skuBarcode",
						label: "条码",
						minWidth: "80",
					},
					{
						prop: "boxMark",
						label: "唛头",
						minWidth: "80",
					},
					{
						prop: "singleBoxQty",
						label: "单箱",
						minWidth: "40",
					},
					{
						prop: "boxQty",
						label: "箱数",
						minWidth: "40",
					},
          {
						prop: "pcs",
						label: "发货数",
						minWidth: "40",
					},
					{
						prop: "boxVolumnDetail",
						label: "长*宽*高",
						minWidth: "90",
					},
					{
						prop: "boxVolumn",
						label: "总体积",
						minWidth: "50",
					},
					{
						prop: "boxWeight",
						label: "总毛重",
						minWidth: "60",
					},
					{
						prop: "deliveryOrdeNo",
						label: "进仓单号",
						minWidth: "80",
					},
          {
						prop: "feeTypeName",
						label: "增值服务",
						minWidth: "80",
					},
					{
						prop: "remark",
						label: "备注",
						minWidth: "120",
					},
          {
						prop: "storages",
						label: "仓位",
						minWidth: "200",
					},]);
      }
          this.printPickListVisible = true;
          this.boxPrint = res.data.response.stockingListDetail;
          this.outbountPrint = res.data.response;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //打印装车单
    printLoadCar() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      var that = this;
      stockingListStatusPrint({ jpContainNo: row[0].jpContainNo }).then(
        (res) => {
          if (res.data.success) {
            this.initTable();
            this.printPickListVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },
    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
      this.warehouseList = user.warehouseList;
      getReadyforTaskBasis("").then((res) => {
        this.transportList = res.data.response.transportdata;
        this.statuslist = this.formatterOption(
          res.data.response.outboundStatusdata,
          "outboundText",
          "outboundId"
        );
      });
    },
    formatterOption(option, labelKey, valueKey) {
      return (
        option &&
        option.map((item) => {
          item.label = item[labelKey];
          item.value = item[valueKey];
          return item;
        })
      );
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    let user = JSON.parse(window.localStorage.user);
    this.organizationList = user.organizationList;
    console.log(this.buttonList);
    this.getBasicdatalist();
  },
};
</script>

<style lang="less">
.content-az {
  overflow-x: hidden;
}
.printDalog {
  .el-dialog__body {
    padding-top: 0;
  }
}
.printRow {
  position: absolute;
  right: 20px;
}
.dialogClass {
  .el-dialog {
    .el-dialog__body {
      //border-top: 1px solid #dcdfe6;
      //border-bottom: 1px solid #dcdfe6;
      max-height: 2000px !important;
      min-height: 500px;
      overflow-y: hidden;
    }
  }
  .el-dialog.is-fullscreen {
    max-height: 2000px !important;
    min-height: 500px;
  }
}
.printList {
  font-size: 16px;
  margin-bottom: 14px;
}
#completeDivd {
  font-size: 16px;
  width: 80%;
  margin: 0 auto;
}
</style>

<style type="text/css" media="print">
@page {
  margin-top: 5mm;
  margin-bottom: 18mm;
  padding-top: 5mm;
}
</style>

<style>
figure {
  page-break-inside: avoid;
}
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
.printClass2 th > .cell {
  padding-right: 0px !important;
}
.printClass2 .cell {
  padding-right: 0px !important;
}
</style>
